var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import { getUserData } from "../../../actions/user";
import { getSubscriptions } from "../../actions/userSettings";
import UserHeader from "../../../components/Library/UserHeader";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";

import ProfileSettings from "./ProfileSettings";
import SocialSettings from "./SocialSettings";
import SubscriptionSettings from "./SubscriptionSettings";

import styles from "./UserSettings.css";

var UserSettings = function (_Component) {
  _inherits(UserSettings, _Component);

  function UserSettings() {
    _classCallCheck(this, UserSettings);

    return _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).apply(this, arguments));
  }

  _createClass(UserSettings, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getUserData();
      this.props.getSubscriptions();
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(
        Layout,
        { className: styles.root, includeHeader: true, headerComponent: React.createElement(UserHeader, { person: { display_name: this.props.userSettings.data.profileInfo.display_name } }) },
        React.createElement(
          Sidebar,
          { className: styles.sidebar },
          React.createElement(
            Link,
            { to: "/users/saved-stories", className: styles.sidebarLinks },
            "Saved Stories"
          ),
          React.createElement(
            Link,
            { to: "/users/settings", className: classNames(styles.sidebarLinks, styles.active) },
            "Account"
          )
        ),
        React.createElement(
          Content,
          null,
          React.createElement(ProfileSettings, null),
          React.createElement(SocialSettings, null),
          React.createElement(SubscriptionSettings, null)
        )
      );
    }
  }]);

  return UserSettings;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    userSettings: state.userSettings
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getUserData: bindActionCreators(getUserData, dispatch),
    getSubscriptions: bindActionCreators(getSubscriptions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);


// WEBPACK FOOTER //
// ./src/users/components/UserSettings/UserSettings.js